import { AutogenModelTia3plSurveyControl, AutogenRowTia3plSurveyControl } from "./autogen/AutogenModelTia3plSurveyControl";

export class ModelTia3plSurveyControl extends AutogenModelTia3plSurveyControl<RowTia3plSurveyControl> {
	constructor() {
		super(RowTia3plSurveyControl);
	}
}

export class RowTia3plSurveyControl extends AutogenRowTia3plSurveyControl {
}